/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InviteUsers_Mutation = { readonly __typename: 'Mutation', readonly inviteUsers: ReadonlyArray<string | null> | null };


export type InviteUsersVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
  emails: ReadonlyArray<_Types.InputMaybe<_Types.Scalars['String']['input']>> | _Types.InputMaybe<_Types.Scalars['String']['input']>;
}>;


export type InviteUsers = InviteUsers_Mutation;


export const InviteUsersDocument = gql`
    mutation InviteUsers($creditApplicationId: ID!, $emails: [String]!) {
  inviteUsers(creditApplicationId: $creditApplicationId, emails: $emails)
}
    `;
export type InviteUsersMutationFn = Apollo.MutationFunction<InviteUsers, InviteUsersVariables>;

/**
 * __useInviteUsers__
 *
 * To run a mutation, you first call `useInviteUsers` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUsers` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUsers, { data, loading, error }] = useInviteUsers({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useInviteUsers(baseOptions?: Apollo.MutationHookOptions<InviteUsers, InviteUsersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUsers, InviteUsersVariables>(InviteUsersDocument, options);
      }
export type InviteUsersHookResult = ReturnType<typeof useInviteUsers>;
export type InviteUsersMutationResult = Apollo.MutationResult<InviteUsers>;
export type InviteUsersMutationOptions = Apollo.BaseMutationOptions<InviteUsers, InviteUsersVariables>;